<script>
export default {
	name: "ZendeskChat",
	render() {
		return false;
	},
	mounted() {
		this.loadScript();
	},
	methods: {
		loadScript() {
			let vm = this;
			return new Promise((resolve, reject) => {
				let src = vm.env.zendeskChat.url;
				let id = "ze-snippet";
				if (
					document.getElementById(id) &&
					document.getElementById(id).src == src
				)
					return resolve(true);

				let script = document.createElement("script");
				script.onload = () => resolve(true);
				script.id = id;
				script.src = src;
				document.head.appendChild(script);
			});
		},
	},
};
</script>
